import React from "react";
import sanitizeHtml from "sanitize-html";
import { LineBreaksProps } from "./line-breaks.props";

export const LineBreaks = (props: LineBreaksProps) => (
  <span
    dangerouslySetInnerHTML={{
      __html: sanitizeHtml(props.text).replaceAll("\n", "<br/>"),
    }}
  />
);
